var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '../../config/request';
export const fetchJurnal = createAsyncThunk('jurnal/fetch', (_, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const resDopusk = yield request('/jurnal/dopusk/1');
        const resDopuskDetal = yield request('/jurnal/dopusk-detal/1');
        const resVidDopusk = yield request('/jurnal/vid-dopusk/1');
        return { dopusk: resDopusk.data, dopuskDetal: resDopuskDetal.data, vidDopusk: resVidDopusk.data };
    }
    catch (e) {
        return thunkAPI.rejectWithValue('Ошибка');
    }
}));
